<template>
    <div class="upload-video-modal">
        <b-modal
            id="document-preview-popup"
            title="Document Preview"
            size="md"
            ok-only
            ok-title="Close"
            ok-variant="primary"
            no-close-on-backdrop
            no-close-on-esc
            @show="onShow"
        >
            <h5>Recorded Video</h5>
            <div class="document-preview-section video-modal">
                <div v-if="item && item.fileName" class="preview-video">
                    <video
                        ref="video"
                        v-authenticated-image="item.thumbNail"
                        playsinline
                        :src="video"
                        preload="none"
                        @click="stopVideo"
                        @ended="onEnd()"
                    >
                        Your browser does not support HTML5 video.
                    </video>
                </div>

                <img
                    v-if="play == false"
                    :src="require('@/assets/images/play.png')"
                    class="play-btn"
                    @click="startVideo"
                />
            </div>
        </b-modal>
    </div>
</template>

<script>
import request from '@/utils/request'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */

    props: {
        item: {
            type: Object,
            default: null,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */

    data() {
        return {
            play: false,
            video: '',
            defaultPoster: '',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        startVideo() {
            this.play = true
            this.$refs.video.play()
        }, // End of startVideo() method

        stopVideo() {
            this.play = false
            this.$refs.video.pause()
        }, // End of stopVideo() method

        /**
         *
         * @return {void}
         */
        async onShow() {
            this.play = false

            try {
                let response = await request({
                    url: `/files/${this.item.fileName}`,
                    responseType: 'arraybuffer',
                })
                if (this.$refs.video && !this.$refs.video.poster) {
                    this.$refs.video.poster = this.defaultPoster
                }
                let mimeType = response.headers['content-type'].toLowerCase()

                let imgBase64 = new Buffer(response.data, 'binary').toString(
                    'base64'
                )
                this.video = `data:${mimeType};base64,${imgBase64}`
                if (this.$refs.video.poster) {
                    this.defaultPoster = this.$refs.video.poster
                }
            } catch (error) {
                //console.log(error)
            }
        }, // End of onShow() method

        onEnd() {
            this.play = false
        }, // End of onEnd() method
    }, // End of Component > methods
}
</script>
